import React from 'react';
import store from '../../store/Store';
import './admin.scss';

type adminState = {

}

type adminProps = {
	login: {
		loggedIn
	},
	user: {
		id,
		title,
		name,
		lastName,
		gender,
		email,
		password,
		admin
	}
}

class Admin extends React.Component<adminState, adminProps> {

	constructor(props) {
		super(props)

		this.state = {
			login: {
				loggedIn: store.getState().login && store.getState().login.loggedIn ? store.getState().login.loggedIn : false
			},
			user: {
				id: store.getState().user && store.getState().user.id ? store.getState().user.id : 0,
				title: store.getState().user && store.getState().user.title ? store.getState().user.title : '',
				name: store.getState().user && store.getState().user.name ? store.getState().user.name : '',
				lastName: store.getState().user && store.getState().user.lastName ? store.getState().user.lastName : '',
				gender: store.getState().user && store.getState().user.gender ? store.getState().user.gender : -1,
				email: store.getState().user && store.getState().user.email ? store.getState().user.email : '',
				password: store.getState().user && store.getState().user.password ? store.getState().user.password : '',
				admin: store.getState().user && store.getState().user.admin ? store.getState().user.admin : ''
			}
		}

		store.subscribe(() => {
			this.setState({
				login: {
					loggedIn: store.getState().login && store.getState().login.loggedIn ? store.getState().login.loggedIn : false
				},
				user: {
					id: store.getState().user && store.getState().user.id ? store.getState().user.id : 0,
					title: store.getState().user && store.getState().user.title ? store.getState().user.title : '',
					name: store.getState().user && store.getState().user.name ? store.getState().user.name : '',
					lastName: store.getState().user && store.getState().user.lastName ? store.getState().user.lastName : '',
					gender: store.getState().user && store.getState().user.gender ? store.getState().user.gender : -1,
					email: store.getState().user && store.getState().user.email ? store.getState().user.email : '',
					password: store.getState().user && store.getState().user.password ? store.getState().user.password : '',
					admin: store.getState().user && store.getState().user.admin ? store.getState().user.admin : ''
				}
			})
		})
	}

	componentDidMount() {
		
	}

	render() {
		return (
			<div className="Admin">
				<div className="AdminHeader">

				</div>
				<div className="AdminContent">
					<div>
						Administrative Operations
					</div>
					
					<div>
						Categorymanagement <br />
						Create Category <br />
						Update Category <br />
						Delete Category <br />
						Send Category Mail <br />
					</div>

					<div>
						Projectmanagement <br />
						Create Project <br />
						Update Project <br />
						Delete Project <br />
						Send Project Mail <br />
					</div>

					<div>
						Usermanagement <br />
						Create User <br />
						Update User <br />
						Delete User <br />
						Send User Mail <br />
					</div>
				</div>
				<div className="AdminFooter">

				</div>
			</div>
		);
	}
}

export default Admin;
